import { BalanceData } from "../data/balance";
import { Pcg32 } from "../maths/pcg32";
import { metaSeed } from "./orders";

/**
 * The Mystery Merchant's free item (MP-08; shops.json merchant `freePerDay`): in a game without ads, the free "something
 * today" an ad-funded game hands out for watching one. One of the non-gear slots, picked from (player, UTC day) apart
 * from the day's roll, sells for nothing until it is taken that day; a refresh before then keeps a free slot, so it is
 * never lost and never doubled (ShopsState `merchantFreeDay`).
 */

/** Pcg32 stream of the free slot's pick, apart from every other use of the same seed. */
const FREE_STREAM = 439;

/** The Merchant slot index that is free on UTC `day` for this player, or −1 when the data has none. */
export function merchantFreeIndex(balance: BalanceData, playerId: string, day: number): number {
  const m = balance.shops.merchant, n = m.slots - m.gearSlots;
  if (m.freePerDay <= 0 || n <= 0) return -1;
  return m.gearSlots + new Pcg32(metaSeed(playerId, "merchantFree", day), FREE_STREAM).nextInt(n);
}

/** The stock with slot `index` free (price 0, `free` set); `index` −1 leaves it as it is. */
export function withFreeSlot<T extends { readonly index: number; readonly price: number }>(slots: readonly T[], index: number): T[] {
  return slots.map((s) => (s.index === index ? { ...s, price: 0, free: true } : s));
}
